import React from "react";
import { Phone, CalendarClock, Clock } from "lucide-react";
import { contactInfo } from "../mock";

export default function InfoBar() {
  return (
    <section className="bg-[#0e1b34] text-white -mt-16 relative z-20">
      <div className="container-x grid grid-cols-1 md:grid-cols-3">
        {/* Emergency */}
        <div className="p-8 md:p-10 flex gap-5 items-start bg-[#0e1b34]">
          <div className="w-14 h-14 rounded-sm bg-[#c9a961]/15 border border-[#c9a961]/40 flex items-center justify-center flex-shrink-0">
            <Phone className="text-[#c9a961]" size={22} />
          </div>
          <div>
            <h3 className="font-serif-display text-xl mb-2">Emergency Cases?</h3>
            <p className="text-sm text-neutral-300 mb-2">Contact for Quick Legal Assistance:</p>
            <a href={`tel:${contactInfo.phone}`} className="text-[#c9a961] font-semibold hover:underline">
              {contactInfo.phone}
            </a>
          </div>
        </div>

        {/* Legal Help */}
        <div className="p-8 md:p-10 flex gap-5 items-start bg-[#14264a] relative">
          <div className="w-14 h-14 rounded-sm bg-[#c9a961]/15 border border-[#c9a961]/40 flex items-center justify-center flex-shrink-0">
            <CalendarClock className="text-[#c9a961]" size={22} />
          </div>
          <div>
            <h3 className="font-serif-display text-xl mb-2">Need Legal Help?</h3>
            <p className="text-sm text-neutral-300 mb-3">Fix an Appointment for advice, guidance or assistance on any Legal Matter.</p>
            <a href="#appointment" className="text-[#c9a961] font-semibold hover:underline text-sm">
              Fix An Appointment &rarr;
            </a>
          </div>
        </div>

        {/* Working Hours */}
        <div className="p-8 md:p-10 flex gap-5 items-start bg-[#0e1b34]">
          <div className="w-14 h-14 rounded-sm bg-[#c9a961]/15 border border-[#c9a961]/40 flex items-center justify-center flex-shrink-0">
            <Clock className="text-[#c9a961]" size={22} />
          </div>
          <div>
            <h3 className="font-serif-display text-xl mb-2">Working Hours</h3>
            {contactInfo.hours.map((h, i) => (
              <div key={i} className="text-sm text-neutral-300">
                <span className="text-white font-medium">{h.day}: </span>
                {h.time}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
